module.exports = __webpack_public_path__ + "../resources/img/bg_storage2_02.0fddf5f7.png";